import { verificarIdentificacaoPositiva } from '../api/pessoaAPI';
import { IdentificacaoPositivaModel } from '../model/IdentificacaoPositiva';
class AuthIdPositiva {

  async login(identificacaoPositiva: IdentificacaoPositivaModel) {
    const data = await verificarIdentificacaoPositiva(identificacaoPositiva);

    sessionStorage.setItem('isLoggedIn_idPositiva', 'true');
    
    sessionStorage.setItem('user_idPositiva', JSON.stringify(data.pessoa));
    sessionStorage.setItem('userId_idPositiva', data.pessoa.identificador);

    const autenticado = this.isAuthenticated();
    const dados = {data, autenticado};

    return dados;
  }

  isAuthenticated() {
    return sessionStorage.getItem('isLoggedIn_idPositiva') === 'true';
  }

  logout() {
    sessionStorage.removeItem('isLoggedIn_idPositiva');
    sessionStorage.removeItem('user_idPositiva');
    sessionStorage.removeItem('userId_idPositiva');
    sessionStorage.removeItem('user_termo_de_uso_assinado');
  }

  getUser() {
    return JSON.parse(sessionStorage.getItem('user_idPositiva')||'');
  }

  getUserId() {
    return sessionStorage.getItem('userId_idPositiva');
  }
}

const authIdPositiva = new AuthIdPositiva();

export default authIdPositiva;
